import { AssetEvent } from '@/types/assets';
import {
  Flex,
  IconInCircle,
  IconNames,
  sizes,
  spaces,
  Text,
} from '@electricjs/arc';
import {
  AssetActionEnum,
  CalculatedEventTypes,
} from '@electricjs/core_entity-client';
import {
  DeviceHealthIssueIconMap,
  EventTypeIconMap,
} from '@/components/Assets/AssetEventsHistory/types';
import { DeviceIssueType } from '@/types/devices';
import { useTranslation } from 'react-i18next';
import { formatEventDescription } from '../helpers/formatAssetEventHistory';
import {
  EventDescriptionTranslationKeysEnum,
  getChangeMdmStatusOverrideTranslationKey,
} from '../helpers/AssetEventHistoryFormatters';

const getIcon = (event: AssetEvent): IconNames => {
  if (
    event.actionType === CalculatedEventTypes.DeviceHealthIssue &&
    event.extraInfo?.issue_type &&
    DeviceHealthIssueIconMap[event.extraInfo?.issue_type as DeviceIssueType]
  ) {
    return DeviceHealthIssueIconMap[
      event.extraInfo?.issue_type as DeviceIssueType
    ];
  }

  if (event.actionType === AssetActionEnum.ChangeMdmStatusOverride) {
    const translationKey = getChangeMdmStatusOverrideTranslationKey(
      event.action
    );
    if (
      translationKey ===
      EventDescriptionTranslationKeysEnum.ChangeMdmStatusOverrideSet
    ) {
      return 'shield-xmark';
    }
    if (
      translationKey ===
      EventDescriptionTranslationKeysEnum.ChangeMdmStatusOverrideCleared
    ) {
      return 'shield-check';
    }
  }

  if (EventTypeIconMap[event.actionType]) {
    return EventTypeIconMap[event.actionType] as IconNames;
  }

  return 'laptop';
};

type EventCellProps = {
  event: AssetEvent;
};

export const EventCell = ({ event }: EventCellProps) => {
  const { t } = useTranslation('assets');
  const { space_m } = spaces;
  const { size_40 } = sizes;
  const formattedEvent = formatEventDescription(event, t);

  return (
    <Flex gap={space_m} alignItems="center">
      <Flex>
        <IconInCircle
          icon={getIcon(event)}
          size={size_40}
          customIconSize="20px"
        />
      </Flex>
      <Text variant="body-2">{formattedEvent}</Text>
    </Flex>
  );
};
